<template>
  <b-modal
    v-if="patient"
    ref="modalPatientCard"
    size="xl"
    hide-footer
    :title="$t('global.infoPatient')"
    centered
    modal-class="modalPatientCard"
    style="z-index:10000"
  >
    <!--Datos personales-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-user mr-2"
              aria-hidden="true"
            />{{ $t('global.personalData') }}
          </div>

          <!--Row: Case 2-->
          <b-row>
            <b-col
              v-for="patientIdentifier in patient.patientIdentifiers"
              :key="patientIdentifier.paiId"
              md="3"
              cols="4"
              class="custom-width structure__data"
            >
              <small>{{ patientIdentifier.identifierType.name }} {{ patientIdentifier.identifierType.code === PATIENT_IDENTIFIER_CODES.NHC ?
                ` - ${patientIdentifier.center.name}` : '' }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patientIdentifier.paiIdentifier || patientIdentifier.centerPaiIdentifier }}
              </h4>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.name',1) }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.patName }}
              </h4>
            </b-col>
            <b-col
              v-if="globalParameters.middleNameSupported"
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('global.middleName') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.patMiddleName }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('global.surname1') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.patSurname1 }}
              </h4>
            </b-col>
            <b-col
              v-if="globalParameters.secondSurnameSupported"
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('global.surname2') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.patSurname2 }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('global.birthday') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.patBirthdate | date }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.gender') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.gender.name }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <!--fin bloque-->

    <!--Datos contacto-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-envelope mr-2"
              aria-hidden="true"
            />{{ $t('global.contactData') }}
          </div>

          <b-row>
            <b-col
              v-if="patient.address"
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.address',1) }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.address.address }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $t('global.pc') }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.address.postalCode }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.municipality',1) }}</small>
              <h4
                v-if="patient.address.municipality"
                class="collapsable-card-title inside"
              >
                {{ patient.address.municipality.name }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.province',1) }}</small>
              <h4
                v-if="patient.address.province"
                class="collapsable-card-title inside"
              >
                {{ patient.address.province.name }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.country',1) }}</small>
              <h4
                v-if="patient.address.country"
                class="collapsable-card-title inside"
              >
                {{ patient.address.country.name }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.phone',1) }} 1</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.contactInformation.mainPhone }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.phone',1) }} 2</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.contactInformation.otherPhone1 }}
              </h4>
            </b-col>
            <b-col
              md="3"
              cols="4"
              class="structure__data"
            >
              <small>{{ $tc('global.phone',1) }} 3</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.contactInformation.otherPhone2 }}
              </h4>
            </b-col>
            <b-col
              md="12"
              class="structure__data"
            >
              <small>{{ $tc('global.email',1) }}</small>
              <h4 class="collapsable-card-title inside">
                {{ patient.contactInformation.email }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <!--fin bloque-->

    <!--Datos Observaciones-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <div class="structure__heading">
            <i
              class="far fa-comment-lines mr-2"
              aria-hidden="true"
            />{{ $t('global.observations') }}
          </div>

          <!--Fila-->
          <b-row class="d-flex pl-3 pr-3">
            <div class="col pl-0 pr-0 structure__data">
              <h4 class="collapsable-card-title inside">
                {{ patient.notes && patient.notes.text ? patient.notes.text : $t('global.noObservations') }}
              </h4>
            </div>
          </b-row>
          <!--Fin Fila-->
        </div>
      </b-col>
    </b-row>
    <!--fin bloque-->
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <!-- <div class="col-6 text-right">
          <b-button size="sm" class="btn--primary"><i class="fal fa-print mr-2" aria-hidden="true"></i>{{ $t('global.print') }}</b-button>
        </div> -->
      </div>
    </div>
  </b-modal>
</template>

<script>
import patientResource from '@/api/resources/PatientResource'
import { PATIENT_IDENTIFIER_CODES } from '@/api/resources/IdentifierRegexesService'

export default {
    name: 'ModalPatientCard',
    props: {
        patientId: { type: Number, required: false }
    },
    data() {
        return {
            patient: null,
            PATIENT_IDENTIFIER_CODES: PATIENT_IDENTIFIER_CODES
        }
    },
    methods: {
        async show(patientFromHis) {
            if (patientFromHis) {
                this.patient = patientFromHis
            } else {
                this.patient = await patientResource.findById(this.patientId)
            }
            this.$nextTick(() => { this.$refs.modalPatientCard.show() })
        },
        hide() {
            this.$refs.modalPatientCard.hide()
        }
    }
}
</script>

<style lang="scss">

  .modalPatientCard .modal-body {
    padding: 0.6rem 1.1rem 0 1.1rem !important;
    border-radius: 0.3rem;
  }

</style>

<style scoped>

  .collapsable-card-title {
    font-weight: normal;
  }

</style>
